//@dependencies
import PropTypes from "prop-types";
//local imports
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
//styles
import styles from "./Popup.module.scss";
import { Grid2 } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function Popup(props) {
  //props and hooks
  const {
    trigger,
    closePopup,
    backPopup,
    children,
    buttons,
    header,
    subHeader,
    subSideHeader,
    image,
    image1,
    tempPlans,
    removed,
    ...rest
  } = props;

  return trigger ? (
    <Grid2 {...rest} className={styles.popupContainer}>
      <Grid2 className={styles.containerStyles}>
        <Grid2 className={styles.popupDomainContainer}>
          {closePopup ? (
            removed ? (
              ""
            ) : (
              <Grid2
                onClick={() => {
                  closePopup();
                }}
              >
                <CloseIcon className={styles.popupCloseButton} />
              </Grid2>
            )
          ) : (
            ""
          )}

          <Grid2 {...rest} item className={styles.addDomainHeader}>
            {backPopup && (
              <span
                onClick={() => {
                  backPopup();
                }}
                className={styles.popupBackButton}
              >
                <ArrowBackIosNewIcon
                  style={{ height: "30px", width: "20px", cursor: "pointer" }}
                />
              </span>
            )}
            <Grid2 className={styles.header}>{header}</Grid2>
            <Grid2 className={styles.subHeader}>{subHeader}</Grid2>
          </Grid2>
          <Grid2 className={styles.padding}>
            <Grid2>{children}</Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  ) : null;
}

//types
Popup.propTypes = {
  trigger: PropTypes.bool,
  closePopup: PropTypes.func,
  backPopup: PropTypes.func,
  children: PropTypes.node,
  header: PropTypes.string,
  subHeader: PropTypes.string,
  subSideHeader: PropTypes.string,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      onClick: PropTypes.func,
      text: PropTypes.string,
    })
  ),
};
